type Env = {
  readonly ENVIRONMENT: string
  readonly RELEASE: string
  readonly SENTRY_DSN: string
  readonly STRIPE_PUBLISHABLE: string
  readonly HUGINN_ID: string
}

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    readonly env: Env
  }
}

export default (envName: keyof Env) =>
  typeof window !== "undefined" ? window.env[envName] : ""
